export default {
  additionalExam: {},
  additionalExams: [],
}
